import { c as _c } from "react/compiler-runtime";
import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UserPlanInterface, UserResourcesInterface, tableFeatures } from 'modules/profile/user-plan/types/user-plan-interface';
import { getPricePlanFeatureTitle, isPricePlanFeatureExceeded } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface ActiveUserPlanColumnProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  userRecourses: UserResourcesInterface;
  showWithTax: boolean;
}
const ActiveUserPlanColumn = t0 => {
  const $ = _c(11);
  const {
    pricePlan,
    billingPeriod,
    userRecourses,
    showWithTax
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== billingPeriod || $[1] !== pricePlan || $[2] !== showWithTax) {
    t1 = <HeaderBlock pricePlan={pricePlan} billingPeriod={billingPeriod} active={true} showWithTax={showWithTax} />;
    $[0] = billingPeriod;
    $[1] = pricePlan;
    $[2] = showWithTax;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pricePlan || $[5] !== t || $[6] !== userRecourses) {
    t2 = tableFeatures.map((column, index) => <React.Fragment key={`active-column-${column.key}`}><div className={twMerge("text-text-primary font-inter truncate text-center text-base", isPricePlanFeatureExceeded(userRecourses, pricePlan, column) && "text-danger")}>{(column.resourceKey ? `${userRecourses[column.resourceKey]}/` : "").concat(getPricePlanFeatureTitle({
          pricePlan,
          key: column.key,
          t
        }))}</div>{tableFeatures[index + 1] ? <hr className="border-fill-primary -mr-6 border-solid" /> : <div />}</React.Fragment>);
    $[4] = pricePlan;
    $[5] = t;
    $[6] = userRecourses;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="border-brand-primary bg-brand-primary/[0.06] slideScrollSnapAlignStart flex w-full min-w-full flex-col gap-2 rounded-sm border border-solid lg:grid">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default ActiveUserPlanColumn;